export const Action = {
  AcceptOrReject: "AcceptOrReject",
  Review: "Review",
  DraftProposalReview: "DraftProposalReview",
  DraftProposalReviewApproved: "DraftProposalReviewApproved",
  ProposalReview: "ProposalReview",
  ProposalReviewApproved: "ProposalReviewApproved",
  ReviewOrReject: "ReviewOrReject",
  ProposalRevisionReview: "ProposalRevisionReview",
  HireOrCancel: "HireOrCancel",
  Hired: "Hired",
} as const;

export type Action = (typeof Action)[keyof typeof Action];
export const ActionEnum = Object.values(Action) as [Action, ...Action[]];
